<template>
  <Section
    decoration="/images/wave.svg"
    :index="5"
    :title="t('sections.projects')"
    id="projects"
  >
    <ul class="projects">
      <li
        v-for="project in projects"
        :key="project.name"
        class="projects__item"
      >
        <a
          :href="project.link"
          target="_blank"
          rel="noopener noreferrer"
          class="projects__link"
        >
          <div class="projects__picture">
            <img
              v-if="project.image"
              :src="`/gifs/${project.image}`"
              :alt="project.name"
              class="projects__image"
            />
          </div>
          <div class="projects__name">
            {{ project.name }}
          </div>
          <p class="">
            {{ project.description }}
          </p>
        </a>
      </li>
    </ul>
  </Section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Section from '@/ui/Section.vue';

type Project = {
  name: string;
  description: string;
  image: string;
  link: string;
}

const { t, tm } = useI18n();

const projects = computed<Project[]>(() => tm('projects'));
</script>

<style lang="scss" scoped>
@use '@/styles/screens';

.projects {
  display: flex;
  gap: 16px;
}

.projects__item {
  border: 1px solid var(--color-border);
  transition: border-color 0.3s ease-in-out;
  max-width: 340px;

  &:hover {
    border-color: var(--color-highlight);
  }
}

.projects__link {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  text-decoration: none;
}

.projects__picture {
  border: 1px solid var(--color-border);
  overflow: hidden;
  height: auto;
  width: 100%;

  &:hover .projects__image {
    transform: scale(1.05);
  }
  
  @include screens.tablet {
    height: 200px;
  }
}

.projects__image {
  display: block;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease-in-out;
  width: 100%;
}

.projects__name {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-size: 18px;
  font-weight: 400;
}
</style>
